import { httpRequest } from '@/utils/axios';

export const getBlogConfig = (data: { types: string[] }) =>
  httpRequest('GET:/api/blog/get_blog_config', { params: data } as any);

export const getBlogTopReadArticles = (data: {
  scene?: number;
  type_id?: number | null | string;
}) => {
  return httpRequest('GET:/api/blog/get_top_hits', { params: data } as any);
};

export const getBlogArticles = (
  data: {
    page: number;
    limit: number;
    order?: string;
    name?: string;
    type?: string | number;
    type_ids?: string[];
    type_id?: string | null | number;
    blog_author_id?: string | number;
    tag_id?: string | number;
  },
  requestOptions?: {
    signal?: AbortSignal;
  },
) =>
  httpRequest(
    'GET:/api/blog/lists',
    { params: data } as any,
    { success: false, fail: true },
    requestOptions,
  );

export const getAuthorList = (data: { page: number; limit: number }) =>
  httpRequest('GET:/api/blog/get_blog_author_list', { params: data } as any);

export const getAuthorDetail = (data: { author_path: string; page: number; limit: number }) =>
  httpRequest('GET:/api/blog/get_blog_author_detail', { params: data } as any);

/**
 * 获取标签列表
 */
export const getTagCount = () => httpRequest('GET:/api/blog/get_tag_count');
interface TagListParams {
  tag_id: number;
  page: number;
  limit: number;
}

/**
 * 获取标签下的文章列表
 */
export const getTagList = (params: TagListParams) =>
  httpRequest('GET:/api/blog/get_tag_list', { params });
